import { AppAuthService } from "@/services/app/auth.service";
import { CommonModule } from "@angular/common";
import { Component, effect, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { TextareaModule } from 'primeng/textarea';
import * as Sentry from "@sentry/angular";
import { FeedbackDialogService } from "@/layout/service/feedback-dialog.service";
import { MessageService } from "primeng/api";


@Component({
    selector: 'app-feedback-widget',
    imports: [
        CommonModule, 
        InputTextModule,
        ButtonModule,
        TextareaModule,
        FormsModule
    ],
    template: `<div class="flex flex-col gap-4">
                    <div class="flex flex-col gap-2">
                        <label for="name1">Name</label>
                        <input [(ngModel)]="name" pInputText id="name1" type="text" />
                    </div>
                    <div class="flex flex-col gap-2">
                        <label for="email1">Email</label>
                        <input [(ngModel)]="email" pInputText id="email1" type="text" />
                    </div>
                    <div class="flex flex-col gap-2">
                        <label for="age1">Describe the bug or feature request</label>
                        <textarea rows="5" pTextarea [autoResize]="true" class="w-full !min-h-20" [(ngModel)]="description"></textarea>
                    </div>
                    <button (click)="captureFeedback()" pButton type="button" label="Submit" class="w-full"></button>
                </div>`,
})
export class FeedbackWidgetComponent {
    authService = inject(AppAuthService);
    feedbackDialogService = inject(FeedbackDialogService);
    messageService = inject(MessageService);
    name: string = '';
    email: string = '';
    description: string = '';
    uid: string = '';

    constructor() {
        effect(() => {
            const userData = this.authService.userData();
            const user = this.authService.userSignal();
            if (userData) {
                this.name = userData.DisplayName ?? '';
                this.email = userData.User ?? '';
            }
            if(user) {
                this.uid = user.sub ?? '';
            }
        });
    }

    captureFeedback() {
        // let eventId = Sentry.lastEventId();
        // if(!eventId) {
        //     eventId = Sentry.captureMessage('User submitted feedback');
        // }
        // const feedback = {
        //     eventId, // Sentry uses this to link to the last captured error
        //     name: this.name,
        //     email: this.email,
        //     message: this.description,
        // };
    
        // try {
        //     const client = Sentry.getClient() as Sentry.BrowserClient;
        //     const feedbackIntegration = client?.getIntegrationByName('Feedback');
        //     if (feedbackIntegration) {
        //         feedbackIntegration.
        //         this.feedbackDialogService.closeFeedback();
        //         this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Feedback sent!', life: 3000 });
        //     } else {
        //         throw new Error('Sentry Feedback integration not found.');
        //     }
        // } catch (error) {
        //     console.error('Error capturing feedback', error);
        //     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error sending feedback', life: 3000 });
        // }
    }
    
}